// Module
var code = "<h1>Hello World</h1> ";
// Exports
export default code;